import { PromptChatAdapter } from '../../components/Chat/PromptChatAdapter';
import { designerChatAgentIds, designerChatScopes, useDesignerChatAdapter } from '../../components/Chat/useDesignerChatAdapter';
import { useDesignerScreenAttributes } from '../../components/Chat/DesignerScreenContext';

export function useHomeChatAdapter(isAvailable: boolean): PromptChatAdapter {
	const getScreenAttributes = useDesignerScreenAttributes();
	return useDesignerChatAdapter({
		scopeName: designerChatScopes.architect,
		agentId: designerChatAgentIds.architect,
		messageAttributes: getScreenAttributes,
		isAvailable,
		missingTargetMessage: 'Sign in to start a conversation with Randol.',
	});
}
